/**
 * @file 慧播星打点
 * @description ubc sdk用法 https://console.cloud.baidu-int.com/devops/icode/repos/baidu/jady/ubc-report-sdk/blob/master/README.md
 * @author
 */

import {ubcLogger, UbcLogger} from '@baidu/ubc-report-sdk';

const aigcScriptId = 17201; // AIGC生成剧本
function log(type, params = {}, action = 'click') {
    try {
        const {value, extParam = {}} = params;
        const {logger, commonParams} = logMap[type];

        logger.send({
            ...commonParams,
            type: action,
            value,
            ext: extParam
        });

        // console.log('log =====>', {
        //     ...commonParams,
        //     type: action,
        //     value,
        //     ext: extParam
        // });
    }
    catch (e) {
        // safe log
    }
}
const aigcScriptLogger = new UbcLogger({
    page: 'huibo',
    ev_l_t: 'editor',
    serverId: aigcScriptId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});
const logMap = {
    aigcScript: {
        logger: aigcScriptLogger,
        commonParams: {
            from: 'aigcScript',
            pos_id: '1662_1664_',
            ev_l_t: 'click'
        }
    }};

export const aigcScriptLog = (tab, params) => {
    const valMap = {
        add: 'add', // 相关埋点 start
        accept_script: 'accept_script', // 采纳使用脚本
        cancel: 'cancel', // 生成商品信息
        asr_click: 'asr_click',
        asr_convert: 'asr_convert',
        asr_use: 'asr_use',
        delete: 'delete',
        copy: 'copy',
        entrance1: 'entrance1',
        entrance2: 'entrance2',
        entrance3: 'entrance3',
        entrance4: 'entrance4'
    };
    log('aigcScript', {
        value: valMap[tab],
        extParam: params
    });
};
export const editScriptLog = (type, params) => {
    const typeKey = Array.isArray(type) ? type[0] : type;
    const valMap = {
        expand: 'AI-extend',
        'adjust_tone': 'AI-modify',
        improve: 'AI-polish',
        reduce: 'AI-simplify'
    };
    console.log(type, '////');
    log('aigcScript', {
        value: valMap[typeKey] || typeKey,
        extParam: params
    });
};